var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgInviteTeammate = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  width: "1em",
  height: "1em",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.47 24.03c.05 3.67 1.98 7.25 5.52 8.6s7.37.21 9.62-2.71 2.55-7.39.74-10.65-5.39-5-8.99-4.25c-4.27.89-6.83 4.79-6.89 9.01 0 .31.07 1.2.53 1.2s.52-.92.53-1.2c.04-2.93 2.26-5.42 4.94-6.36 2.87-1 6.26-.15 8.28 2.14s2.29 5.17.64 7.63-4.73 3.76-7.7 3.27c-3.21-.53-6.11-3.3-6.15-6.67 0-.31-.06-1.2-.53-1.2s-.53.92-.53 1.2ZM16.53 48.05c.04-3.5 1.07-7.11 4.13-9.15 2.23-1.49 4.75-1.62 7.34-1.62s5.05.1 7.28 1.53c3.13 2.01 4.16 5.69 4.19 9.23 0 .31.06 1.2.53 1.2s.53-.92.53-1.2c-.03-3.21-.6-6.65-2.56-9.29-1.56-2.1-3.91-3.34-6.47-3.73-1.88-.29-3.96-.24-5.86-.12-2.57.16-5.03 1.13-6.83 2.99-2.57 2.67-3.29 6.57-3.33 10.14 0 .31.07 1.2.53 1.2s.52-.92.53-1.2Z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M42 33.2h9.29c.85 0 1.73.06 2.58 0H54c.74 0 .75-2.4 0-2.4H42c-.74 0-.75 2.4 0 2.4Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.81 26v9.29c0 .85-.06 1.73 0 2.58V38c0 .74 2.4.75 2.4 0V26c0-.74-2.4-.75-2.4 0Z"
}))));

const ForwardRef = /*#__PURE__*/forwardRef(SvgInviteTeammate);
export default ForwardRef;